import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TAB_TITLE_PREFIX } from '../shared/constants/tab-title-prefix.constants';

@Injectable({ providedIn: 'root' })
export class IxlabTitleStrategy extends TitleStrategy {
    constructor(private readonly title: Title) {
        super();
    }

    public setTitle(title: string, usePrefix: boolean = true) {
        if (!usePrefix) {
            this.title.setTitle(title);
        }

        this.title.setTitle(`${TAB_TITLE_PREFIX}${title}`);
    }

    override updateTitle(routerState: RouterStateSnapshot) {
        const title = this.buildTitle(routerState);

        if (title !== undefined) {
            this.title.setTitle(`${TAB_TITLE_PREFIX}${title}`);
        }
    }
}
